import { Label } from "../../../components/Label";
import { InputSearch } from "../../../components/InputSearch";
import { Radio } from "../../../components/Radio";
import { useState } from "react";

export function StoreStep({ stores, storeId, onChange }) {
  const [storeSearchTerm, setStoreSearchTerm] = useState("");

  const filteredStores = stores.filter((store) => {
    return (
      (!!storeSearchTerm
        ? store.name.toLowerCase().indexOf(storeSearchTerm.toLowerCase()) > -1
        : true)
    );
  });

  return (
    <div >
      <Label>Informe a unidade</Label>
      <InputSearch
        placeholder="Buscar por"
        occurrences={filteredStores.length}
        className="mb-20"
        onChange={(e) => setStoreSearchTerm(e.target.value)}
      />
      {filteredStores.map((store) => {
        return (
          <Radio
            className="mb-5"
            family="unit"
            checked={storeId}
            value={store.storeId}
            onChange={() => onChange({ storeId: store.storeId })}
          >
            {store.name}
          </Radio>
        );
      })}
    </div>
  );
}
